import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="fixed inset-0 bg-[#F9F6F1] flex items-center justify-center z-50">
      <div className="text-center">
        {/* Spinning Vav Icon */}
        <div className="mb-8 flex justify-center">
          <div className="animate-spin">
            <div className="text-[#8B7355] text-8xl font-bold" style={{ fontFamily: '"Traditional Arabic", serif' }}>
              و
            </div>
          </div>
        </div>

        {/* Loading Text */}
        <div className="space-y-2">
          <h2 className="text-2xl font-semibold text-[#5C4033]">Lütfen Bekleyin</h2>
          <p className="text-[#8B7355]">Yükleniyor...</p>
        </div>

        {/* Dots Animation */}
        <div className="flex justify-center space-x-2 mt-6">
          <div className="w-3 h-3 bg-[#8B7355] rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-3 h-3 bg-[#8B7355] rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-3 h-3 bg-[#8B7355] rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;